export default "__VITE_ASSET__DXpLIGXT__"